export async function checkAppVersion(currentVersion) {
  try {
    const res = await fetch('/meta.json', { cache: 'no-store' });
    const { version: serverVersion } = await res.json();
    if (serverVersion !== currentVersion) {
      return { updateAvailable: true, latest: serverVersion };
    }

    return { updateAvailable: false };
  } catch (err) {
    console.error('Error checking app version:', err);
    return { updateAvailable: false };
  }
}
